import React from "react";
import "../CSS/AksesSection.css";
import { FaGlobe, FaMobileAlt, FaBolt, FaCompass } from "react-icons/fa";

const AksesSection = () => {
  return (
    <div className="akses-container">
      <div className="akses-left">
        {/* Judul  */}
        <h2 className="akses-title">
          Akses Fleksibel, <span>Kapan Aja!</span>
        </h2>
    
        {/* Kotak biru */}
        <div className="akses-content">
          <ul>
            <li>
              <FaGlobe className="akses-icon" />
              Buka langsung lewat browser tanpa perlu install aplikasi tambahan
            </li>
            <li>
              <FaMobileAlt className="akses-icon" />
              Tambahkan ke layar utama HP, sehingga terasa seperti aplikasi mobile
            </li>
            <li>
              <FaBolt className="akses-icon" />
              Cepat & Praktis, akses kapan saja dan di mana saja
            </li>
            <li>
              <FaCompass className="akses-icon" />
              Fitur tetap lengkap, mulai dari pemantauan pasien hingga analisis GIS
            </li>
          </ul>
    
          <button className="btn-download">Download</button>
        </div>
      </div>
    
      <div className="akses-right">
        <div className="circle-bg">
          <img src="/assets/gambar8.png" alt="Dokter menunjuk" className="akses-image" />
        </div>
      </div>
    </div>
  );
};

export default AksesSection;
